import { render } from "./MediaFileTypeUnknown.vue?vue&type=template&id=1b3a19b8"
const script = {}
script.render = render

export default script